import { LastTrackerPosition, Vehicle } from "@/interfaces";
import L from "leaflet";

const getVehicleIconPath = (vehicleType: string): string => {
  const type = vehicleType.toLowerCase();

  switch (type) {
    case "truck":
      return "/icons/vehicle/truck.png";
    case "car":
      return "/icons/vehicle/car.png";
    case "motorcycle":
      return "/icons/vehicle/motorcycle.png";
    case "bus":
      return "/icons/vehicle/bus.png";
    default:
      return "/icons/vehicle/car.png";
  }
};

const truncateTitle = (title: string): string => {
  return title.length > 10 ? title.substring(0, 10) : title;
};

const VehicleIcon = (
  vehicle: Vehicle,
  onAlert: boolean,
  heading = 0,
  showHeading = false,
) => {
  const lastPositionData = vehicle.last_position as LastTrackerPosition;
  const iconPath = getVehicleIconPath(vehicle.vehicle_type_name ?? "");
  const truncatedTitle = truncateTitle(vehicle.title);

  let iconColor = "bg-red-500";
  let onAlertClasses = "";

  if (lastPositionData?.ignition) {
    if (lastPositionData?.speed > 0) {
      iconColor = "bg-green-500";
    } else {
      iconColor = "bg-orange-500";
    }
  }

  if (onAlert) {
    onAlertClasses = "animate-pulse-and-flash";
  }

  return L.divIcon({
    className: "custom",
    html: `
          <div class="relative vehicle-marker cursor-pointer" data-vehicle-id="${vehicle.id}">
            <span class="absolute -top-10 -translate-x-1/2 whitespace-nowrap p-1 rounded text-xxs uppercase font-bold shadow-md tracking-wider inline-flex items-center space-x-1 gap-1 text-white ${iconColor} ${onAlertClasses}"
            >
              ${vehicle.plate} ${truncatedTitle}
              ${
                showHeading
                  ? `
              <span class="ml-1 inline-block" style="transform: rotate(${heading}deg);">
                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <line x1="5" y1="12" x2="19" y2="12"></line>
                  <polyline points="12 5 19 12 12 19"></polyline>
                </svg>
              </span>`
                  : ""
              }
            </span>
    
            <div class="absolute -translate-x-1/2 -translate-y-1/2 p-2 rounded-full">
              <img src="${iconPath}" alt="${vehicle.vehicle_type_name}" />
            </div>
          </div>
        `,
    iconSize: [40, 40],
    iconAnchor: [0, 20],
  });
};

export default VehicleIcon;
